import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/images/chat/add-reaction.svg'


const _hoisted_1 = {
  class: "emoji-wrapper",
  ref: "emojiWrapper"
}
const _hoisted_2 = { class: "emoji-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Picker = _resolveComponent("Picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["btn reactions-btn add-reaction-btn", { 'add-reaction-hover': _ctx.isHover }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePicker && _ctx.togglePicker(...args)))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("img", {
          class: _normalizeClass({ 'add-reaction-img': _ctx.isHover }),
          src: _imports_0
        }, null, 2 /* CLASS */)
      ])
    ], 2 /* CLASS */),
    (_ctx.showPicker)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["picker-popup", _ctx.pickerPosition])
        }, [
          _createVNode(_component_Picker, {
            data: _ctx.emojiIndex,
            showPreview: false,
            perLine: 8,
            emojiSize: 18,
            onSelect: _ctx.onEmojiSelect
          }, null, 8 /* PROPS */, ["data", "onSelect"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}